import React from "react";
import ReactSpeedometer from "react-d3-speedometer";

const Speedometer = ({ value, max, label, disabled = false }) => {
  const displayValue = disabled ? 0 : value;
  const displayMax = disabled ? 100 : (max || 100);

  return (
    <div style={{ textAlign: "center", width: "220px", opacity: disabled ? 0.4 : 1 }}>
      <ReactSpeedometer
        maxValue={displayMax}
        value={displayValue}
        needleColor="#1f2937"
        needleTransitionDuration={0}
        needleTransition="easeLinear"
        segments={5}
        segmentColors={disabled
          ? ["#6b7280", "#6b7280", "#6b7280", "#6b7280", "#6b7280"]
          : ["#22c55e", "#84cc16", "#eab308", "#f97316", "#ef4444"]
        }
        ringWidth={35}
        needleHeightRatio={0.7}
        currentValueText=" "
        textColor="#ffffff"
        width={200}
        height={130}
        paddingVertical={5}
        customSegmentLabels={[
          { text: "", position: "INSIDE", color: "transparent" },
          { text: "", position: "INSIDE", color: "transparent" },
          { text: "", position: "INSIDE", color: "transparent" },
          { text: "", position: "INSIDE", color: "transparent" },
          { text: "", position: "INSIDE", color: "transparent" }
        ]}
      />
      <div style={{ marginTop: "-10px", fontSize: "32px", fontWeight: "700", color: "#ffffff" }}>
        {disabled ? "--" : value.toLocaleString()}
      </div>
      <div style={{ display: "flex", justifyContent: "space-between", padding: "0 20px", marginTop: "5px" }}>
        <span style={{ fontSize: "11px", color: "#9ca3af" }}>0</span>
        <span style={{ fontSize: "11px", color: "#9ca3af" }}>{disabled ? "--" : max.toLocaleString()}</span>
      </div>
      <div style={{ fontSize: "13px", color: "#9ca3af", marginTop: "5px", fontWeight: "500" }}>
        {label}
        {disabled && <span style={{ display: "block", fontSize: "11px", fontStyle: "italic" }}>Set in Settings</span>}
      </div>
    </div>
  );
};

export default Speedometer;
